<div id="completeAlert" class="pt-12" fxLayout="row wrap">
    <div fxLayout="column" fxFlex.lt-sm="100%" fxFlex.gt-xs="100">
        
        <div class="section-box info-box general section mt-32" fxLayout="column">

            <header class="accent">
                <div class="title">{{"ALERTS.COMPLETE_ALERT.ALERT_FORM" | translate}}</div>
            </header>

            <div [formGroup]="form" class="complete-alert-detail-content">
                <div class="complete-alert-container m-4">
                    <mat-form-field appearance="outline" class="m-4" style="width: 100%;">
                        <mat-label>{{'ALERTS.ALERT_CODE' | translate}}</mat-label>
                        <input class="p-8" matInput fxFlex="100" readonly [value]="alertDetail?.alertCode"/>
                    </mat-form-field>
            
                    <mat-form-field appearance="outline" class="m-4" style="width: 100%;">
                        <mat-label>{{'ALERTS.ENTITY' | translate}}</mat-label>
                        <input class="p-8" matInput fxFlex="100" readonly [value]="alertDetail?.alertEntity"/>
                    </mat-form-field>
    
                    <mat-form-field appearance="outline" class="m-4" style="width: 100%;">
                        <mat-label>{{'ALERTS.SOURCE' | translate}}</mat-label>
                        <input class="p-8" matInput fxFlex="100" readonly [value]="alertDetail?.sourceDescription"/>
                    </mat-form-field>
    
                    <div style="width: 100%;">
                        <mat-form-field appearance="outline" class="m-4" [ngStyle]="{'width': alertDetail?.complaintId ? '90%' : '99%'}">
                            <mat-label>{{'ALERTS.SOURCE_CODE' | translate}}</mat-label>
                            <input class="p-8" matInput fxFlex="100" readonly [value]="alertDetail?.sourceCode"/>
                        </mat-form-field>
    
                        <button mat-icon-button color="primary" style="width: 7%;"
                            aria-label="view complaint detail"
                            *ngIf="alertDetail.complaintId && buttonDetailComplaint"
                            (click)="viewComplaintDetail()" matTooltip="{{'ALERTS.COMPLETE_ALERT.VIEW_COMPLAINT' | translate}}">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </div>
                    
                    <mat-form-field appearance="outline" class="m-4" style="width: 100%;">
                        <mat-label>{{'ALERTS.FIELDS.CREATEDDATE' | translate}}</mat-label>
                        <input class="p-8" matInput fxFlex="100" readonly [value]="alertDetail?.createDate | date:'dd/MM/yyyy'"/>
                    </mat-form-field>
                </div>
    
                <div class="complete-alert-container m-4">
                    <mat-form-field appearance="outline" class="m-4" style="width: 100%;" floatLabel="always">
                        <mat-label>{{"ALERTS.COMPLETE_ALERT.DETAIL" | translate}}</mat-label>
                        <textarea matInput rows="16" readonly formControlName="description"></textarea>
                    </mat-form-field>
                </div>
            </div>

            <ng-container *ngIf="alertDetail?.complaintId">

                <div [formGroup]="complaintTypeForm" fxLayout="row" fxLayoutAlign="flex-start center">
    
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="15" class="m-8">
                        <mat-label>{{'ALERTS.FIELDS.INTERNALID' | translate}}</mat-label>
                        <input formControlName="internalId" readonly class="p-8" matInput/>
                    </mat-form-field>
        
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="1 1 auto" class="m-8 mr-16">
                        <mat-label>{{'ALERTS.FIELDS.FORMTYPE' | translate}}</mat-label>
        
                        <mat-select formControlName="formTypeId" class="p-8" disabled>          
                            <mat-option *ngFor="let type of complaintTypes" [value]="type.id">
                                <span>{{type.description}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
        
                </div>
    
            </ng-container>
        </div>

    </div>
</div>
<mat-divider></mat-divider>
    

<div id="completeAlert" class="pt-12" fxLayout="row wrap" *ngIf="alertDetail">

    <div fxLayout="column" fxFlex.lt-sm="100%" fxFlex.gt-xs="100">

        <div class="section-box info-box general section" fxLayout="column">

            <header class="accent">
                <div class="title">{{"ALERTS.COMPLETE_ALERT.EVALUATION" | translate}}</div>
            </header>

            <div>
                <app-workflow-history [workflowInstanceId]="alertDetail?.workflowInstanceId"
                    [onContinueObservable]="onContinueSubject.asObservable()"></app-workflow-history>
                <app-workflow-current-step 
                    [onContinueObservable]="onContinueSubject.asObservable()"
                    [workflowInstanceId]="alertDetail?.workflowInstanceId"
                    [entityId]="alertDetail?.id" [readonly]="true">
                </app-workflow-current-step>
            </div>
        </div>
    </div>
</div>
<mat-divider></mat-divider>

<div id="completeAlert" class="pt-12 mb-40" fxLayout="row wrap">

    <div fxLayout="column" fxFlex.lt-sm="100%" fxFlex.gt-xs="100">

        <div class="section-box info-box general section mb-32 pb-12" fxLayout="column">

            <header class="accent">
                <div class="title">{{"ALERTS.COMPLETE_ALERT.NEWS" | translate}}</div>
            </header>
            <div>

                <div *ngFor="let history of alertDetail?.comments" class="my-8">
                    <mat-card class="example-card">
                        <mat-card-subtitle>{{history.createdBy}} - {{history.createdDate | date:'dd/MM/yyyy'}}</mat-card-subtitle>
                        <mat-card-content>
                            <p>{{history.message}}</p>
                        </mat-card-content>

                        <div>
                            <ng-container *ngFor="let file of history.attachments">
                                <button mat-raised-button color="secondary" class="m-4" (click)="downloadNewsFiles(file)"><mat-icon>get_app</mat-icon>{{file.name}}</button>
                            </ng-container>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="mat-card" style="position: absolute;bottom: 1px; width: 100%;right: 12px;">
    <div align="end" class="p-12">
        <button mat-raised-button color="primary" class="m-0 px-8" (click)="onCloseDialog()">{{"ALERT_DIALOG.ACCEPT" | translate}}</button>
    </div>    
</div>